<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75" @click="close()"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-2xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-amaze-coral sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white font-bold">
                                                Manage Bank Accounts for `{{ office.name}}`
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-amaze-coral rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-white">
                                                Get started by selecting the bank accounts to attach to this office.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="space-y-6 pt-6 pb-5">
                                                <h2 class="text-xl text-bold">Bank Accounts</h2>
                                                <div>
                                                    <div class="relative flex items-start" v-for="bank_account in bank_accounts">
                                                        <div class="flex h-5 items-center">
                                                            <input
                                                                   type="checkbox"
                                                                   v-model="form.bank_accounts" :value="bank_account.id"  class="h-4 w-4 rounded border-gray-300 text-amaze-coral focus:ring-amaze-coral">
                                                        </div>
                                                        <div class="ml-3 text-sm">
                                                            <label for="comments" class="font-medium text-gray-700" v-html="bank_account.name + ' / Bank: ' +  bank_account.bank_name + ' (' + bank_account.currency.code + ' - ' + bank_account.currency.symbol + ')'"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="flex-shrink-0 px-4 py-4 flex gap-2 justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-500">
                                        <span v-if="loading === true">Saving Bank Accounts..</span>
                                        <span v-else>Update Bank Accounts</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive, computed} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, QuestionMarkCircleIcon, PencilAltIcon} from '@heroicons/vue/solid'
import {useForm} from '@inertiajs/vue3'
import {mapState, useStore} from "vuex";


export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        XIcon,
        PencilAltIcon
    },
    setup(prop, context) {
        const store = useStore()
        store.dispatch('offices/getData')

        const office = ref(null);
        const loading = ref(null);

        const show = ref(false)

        const form = useForm({
            bank_accounts: null,
        })

        const updating = ref(false);

        function submit() {
            this.loading = true;
            this.creating = true;

                this.form.post(route('admin.offices.office.store-bank-accounts', this.office.id), {
                    onSuccess: (page) => {
                        this.loading = false;
                        this.creating = false;
                        this.close();
                    },
                    onError: (page) => {
                        this.loading = false;
                        this.creating = false;
                        this.showErrors = true;

                    }
                });

        }

        function open(office) {
            this.form.clearErrors();
            this.office = office;
            this.form.bank_accounts = office.bank_accounts
            this.show = true;
        }

        function close() {
            this.show = false;
            this.form.reset();
            this.form.clearErrors();
        }
        return {
            bank_accounts: computed(() => store.state.offices.bank_accounts),
            show,
            form,
            submit,
            office,
            loading,
            open,
            updating,
            close
        }
    }
}
</script>
